webpackJsonp([141916579472825],{

/***/ 1105:
/***/ (function(module, exports) {

	module.exports = {"description":"","displayName":"Wizard","methods":[{"name":"onStepChange","docblock":null,"modifiers":[],"params":[{"name":"step","type":null}],"returns":null}],"props":{"className":{"type":{"name":"string"},"required":false,"description":"Class name of header.","defaultValue":{"value":"''","computed":false}},"showHeader":{"type":{"name":"bool"},"required":false,"description":"Show or hide the header with steps.","defaultValue":{"value":"true","computed":false}},"showHeaderBorder":{"type":{"name":"bool"},"required":false,"description":"Show or hide the header bottom border.","defaultValue":{"value":"true","computed":false}},"showNavigation":{"type":{"name":"bool"},"required":false,"description":"Hide or show Next and Previous Buttons at the bottom.","defaultValue":{"value":"true","computed":false}},"prevBtnOnLastStep":{"type":{"name":"bool"},"required":false,"description":"Show or hide the previous button in the last step (maybe the last step is a thank you message and you don't want them to go back).","defaultValue":{"value":"true","computed":false}},"dontValidate":{"type":{"name":"bool"},"required":false,"description":"Dev control to disable validation rules called in step components.","defaultValue":{"value":"true","computed":false}},"preventEnterSubmission":{"type":{"name":"bool"},"required":false,"description":"By default if you hit the Enter key on any element it validates the form and moves to next step if validation passes. Use this to prevent this behaviour.","defaultValue":{"value":"true","computed":false}},"startAtStep":{"type":{"name":"number"},"required":false,"description":"Specify what step to start from in the case you need to skip steps (send in a 0 based index for the item in the steps array. e.g. 2 will load <Step3 /> initially).","defaultValue":{"value":"0","computed":false}},"nextButtonText":{"type":{"name":"string"},"required":false,"description":"Specify the next button text.","defaultValue":{"value":"'Next'","computed":false}},"backButtonText":{"type":{"name":"string"},"required":false,"description":"Specify the back button text.","defaultValue":{"value":"'Back'","computed":false}},"nextButtonCls":{"type":{"name":"string"},"required":false,"description":"Specify the next button class.","defaultValue":{"value":"'btn btn-primary pull-right'","computed":false}},"backButtonCls":{"type":{"name":"string"},"required":false,"description":"Specify the back button class.","defaultValue":{"value":"'btn btn-primary pull-left'","computed":false}},"nextTextOnFinalActionStep":{"type":{"name":"string"},"required":false,"description":"Specify what the next button text should be in the step before the last.","defaultValue":{"value":"'Next'","computed":false}},"contentAlign":{"type":{"name":"string"},"required":false,"description":"Specify the align of wizard components. Can be <code>'left'</code>, <code>'right'</code> and <code>'center'</code>","defaultValue":{"value":"'left'","computed":false}},"hocValidationAppliedTo":{"type":{"name":"arrayOf","value":{"name":"number"}},"required":false,"description":"Its recommended that you use basic javascript validation.","defaultValue":{"value":"[]","computed":false}},"steps":{"type":{"name":"arrayOf","value":{"name":"shape","value":{"name":{"name":"string","required":true},"component":{"name":"element","required":true}}}},"required":true,"description":"List of steps."},"onStepChange":{"type":{"name":"func"},"required":false,"description":"Called when 'Back' or 'Next' button is clicked.","defaultValue":{"value":"() => {}","computed":false}}},"filename":"/components/Wizard/Wizard.jsx"}

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _main = __webpack_require__(5);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _DetailsComponent = __webpack_require__(6);
	
	var _DetailsComponent2 = _interopRequireDefault(_DetailsComponent);
	
	var _wizard = __webpack_require__(536);
	
	var _wizard2 = _interopRequireDefault(_wizard);
	
	var _map = __webpack_require__(1105);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComponentView = function (_React$Component) {
	  _inherits(ComponentView, _React$Component);
	
	  function ComponentView() {
	    _classCallCheck(this, ComponentView);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ComponentView.prototype.render = function render() {
	    return _react2.default.createElement(
	      _main2.default,
	      { pagePushedFunction: this.handlepushedPageLayout },
	      _wizard2.default && _react2.default.createElement(_DetailsComponent2.default, {
	        name: _wizard2.default.name,
	        linkGithub: 'https://github.com/front10/landing-page-book/tree/master/src/components/Wizard',
	        description: _wizard2.default.summary,
	        stories: _wizard2.default.stories,
	        importCode: _wizard2.default.import,
	        withStyles: _wizard2.default.withStyles,
	        extractProps: _wizard2.default.extractProps,
	        propsDescription: _map2.default.props
	      })
	    );
	  };
	
	  return ComponentView;
	}(_react2.default.Component);
	
	exports.default = ComponentView;
	module.exports = exports['default'];

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	    name: 'Wizard',
	    summary: 'Easy way to make a wizard on your website. you can guide your users step by step.',
	    import: '',
	    withStyles: true,
	    extractProps: ['header'],
	    stories: [{
	        name: 'Basic',
	        summary: '',
	        code: '<Wizard\n    contentAlign="center"\n    steps={[\n    {\n        name: \'Step 1\',\n        component: (\n            <Container>\n                <Video source="https://youtu.be/dCrLwWdju68" />\n            </Container>\n        )\n    },\n    {\n        name: \'Step 2\',\n        component: (\n            <Container>\n                <Gif autoplay image="https://front10.com/landing-page-book/images/gif/write.gif" />\n            </Container>\n        )\n    },\n    {\n        name: \'Step 3\',\n        component: (\n            <form>\n                <FormGroup>\n                    <Input label="Name" labelColon />\n                </FormGroup>\n                <FormGroup>\n                    <Input label="Email" labelColon type="email" />\n                </FormGroup>\n                <FormGroup>\n                    <Input label="Address" labelColon type="textarea" />\n                </FormGroup>\n                <Social url="https://front10.com" type="twitter" />\n                <Social url="https://front10.com" type="linkedin" />\n                <Social url="https://front10.com" type="google" />\n                <Social url="https://front10.com" type="pinterest" />\n            </form>\n        )\n    }\n]} />',
	        tabsActive: ['code']
	    }]
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-components-wizard-js-e1761fdb9df713bea7f3.js